<div class="w-full custom-form flex items-center">
  @if (!loading()) {
    <mat-form-field class="w-full mat-select-tiny">
      <mat-select
        multiple
        [formControl]="selectionControl"
        [hideSingleSelectionIndicator]="true"
        [placeholder]="emptyLabel()"
        (openedChange)="onOpenedChange($event)"
        (closed)="onPanelClosed()"
        (selectionChange)="onSelectionChange($event)"
      >
        <mat-select-trigger>
          <span>{{ triggerLabel() }}</span>
        </mat-select-trigger>

        @if (showSearch()) {
          <mat-option class="contains-mat-select-search">
            <ngx-mat-select-search
              [formControl]="searchControl"
              [placeholderLabel]="searchPlaceholder()"
              [noEntriesFoundLabel]="''"
            >
              <app-icon ngxMatSelectSearchClear src="icons/close.svg" alt="close" [size]="16" />
            </ngx-mat-select-search>
          </mat-option>
        }

        @if (showBulkActions()) {
          <div class="flex items-center" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
            <button
              mat-flat-button
              color="secondary-transparent"
              class="mat-slim-button"
              type="button"
              (click)="onSelectAll($event)"
            >
              {{ 'shared.selectAll' | translate }}
            </button>
            <button
              mat-flat-button
              color="secondary-transparent"
              class="mat-slim-button"
              type="button"
              (click)="onUnselectAll($event)"
            >
              {{ 'shared.unselectAll' | translate }}
            </button>
          </div>
        }

        @if (exclusiveOption()) {
          <mat-option
            class="exclusive-option"
            value="__exclusive__"
            [class.mat-active]="exclusiveOptionActive()"
            (click)="exclusiveOptionToggled.emit(); $event.stopPropagation()"
          >
            {{ exclusiveOption() }}
          </mat-option>

          <mat-divider class="!border-t-shikenso-purple-base-12 !my-1" />
        }

        @for (option of displayedOptions(); track option.value) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }

        @if (searchQuery() && displayedOptions().length === 0) {
          <mat-option class="no-results-option" disabled>{{ 'shared.noResults' | translate }}</mat-option>
        }

        @for (option of hiddenSelectedOptions(); track option.value) {
          <mat-option [value]="option.value" style="display: none">{{ option.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  } @else {
    <ngx-skeleton-loader class="h-[30px]" [theme]="{ height: '30px', width: '252px', 'border-radius': '100vw' }" />
  }
</div>
